// extracted by mini-css-extract-plugin
module.exports = {"emptyList":"EmptyList_emptyList__gRNpv","title":"EmptyList_title__c3jSe","description":"EmptyList_description__JFv7z","button":"EmptyList_button__XW1tz"};